import constants from './constants'
import {
  getCrewsApiCall,
  getUsersApiCall,
  loginApiCall,
  getPermissionsApiCall,
  upsertUserApiCall,
  getUserInfoApiCall,
  logoutApiCall,
  getVendorsApiCall,
  impersonationApiCall,
  doubleLoginApiCall,
  getEmployeesApiCall
} from '../../service/client'
import { logServiceError } from '../../utils/'

const loginFetch = () => ({ type: constants.LOGIN_FETCH })
const loginSuccess = (user) => ({ type: constants.LOGIN_SUCCESS, user })

export const login = (username, password) => dispatch => {
  dispatch(loginFetch())
  const call = username.toLowerCase() === 'admin' ? doubleLoginApiCall : loginApiCall
  return call(username, password)
    .then((res) => {
      dispatch(loginSuccess({ ...res.body, username }))
    })
    .catch(err => {
      logServiceError('login', err)
      return Promise.reject(err)
    })
}

export const confirmUser = (user) => dispatch => {
  dispatch(loginSuccess(user))
}

const logoutFetch = () => ({ type: constants.LOGOUT_FETCH })
const logoutSuccess = () => ({ type: constants.LOGOUT_SUCCESS })
const loginFail = () => ({ type: constants.LOGIN_FAIL })

export const logout = (user) => dispatch => {
  dispatch(logoutFetch())
  return logoutApiCall(user)
    .then(() => {
      if (History.location.pathname !== '/login') History.push('/login')
      dispatch(logoutSuccess())
    })
    .catch(err => logServiceError('logout', err))
}

const usersFetch = () => ({ type: constants.USERS_FETCH })
const usersSuccess = users => ({ type: constants.USERS_FETCH_SUCCESS, users })

export const getUsers = user => dispatch => {
  dispatch(usersFetch())
  return getUsersApiCall(user)
    .then(({ body }) => dispatch(usersSuccess(body)))
    .catch(err => logServiceError('getUsers', err))
}

export const getUserInfo = user => dispatch => {
  dispatch(loginFetch())
  return getUserInfoApiCall(user)
    .then(({ body }) => {
      dispatch(loginSuccess(body))
    })
    .catch(err => {
      dispatch(loginFail())
      logServiceError('getUsers', err)
    })
}

const crewsFetch = () => ({ type: constants.CREWS_FETCH })
const crewsSuccess = crews => ({ type: constants.CREWS_FETCH_SUCCESS, crews })

export const getCrews = user => dispatch => {
  dispatch(crewsFetch())
  return getCrewsApiCall(user)
    .then(({ body }) => dispatch(crewsSuccess(body)))
    .catch(err => {
      logServiceError('getCrews', err)
      return Promise.reject(err)
    })
}


const vendorsFetch = () => ({ type: constants.VENDORS_FETCH })
const vendorsSuccess = vendors => ({ type: constants.VENDORS_FETCH_SUCCESS, vendors })

export const getVendors = user => dispatch => {
  dispatch(vendorsFetch())
  return getVendorsApiCall(user)
    .then(({ body }) => dispatch(vendorsSuccess(body)))
    .catch(err => {
      logServiceError('getVendors', err)
      return Promise.reject(err)
    })
}

const employeesFetch = () => ({ type: constants.EMPLOYEES_FETCH })
const employeesSuccess = employees => ({ type: constants.EMPLOYEES_FETCH_SUCCESS, employees })

export const getEmployees = user => dispatch => {
  dispatch(employeesFetch())
  return getEmployeesApiCall(user)
    .then(({ body }) => dispatch(employeesSuccess(body)))
    .catch(err => {
      logServiceError('getVendors', err)
      return Promise.reject(err)
    })
}

const permissionsFetch = () => ({ type: constants.PERMISSIONS_FETCH })
const permissionsSuccess = permissions => ({ type: constants.PERMISSIONS_FETCH_SUCCESS, permissions })

export const getPermissions = user => dispatch => {
  dispatch(permissionsFetch())
  return getPermissionsApiCall(user)
    .then(({ body }) => dispatch(permissionsSuccess(body)))
    .catch(err => logServiceError('getPermissions', err))
}

const upsertUserFetch = () => ({ type: constants.UPSERT_USER_FETCH })
const upsertUserSuccess = user => ({ type: constants.UPSERT_USER_SUCCESS, user })

export const upsertUser = (user, newUser) => dispatch => {
  dispatch(upsertUserFetch())
  return upsertUserApiCall(user, newUser)
    .then(() => dispatch(upsertUserSuccess(newUser)))
    .catch(err => logServiceError('upsertUser', err))
}

export const startImpersonation = (user, impersonatedUser) => dispatch => {
  impersonationApiCall(user, impersonatedUser.Username).then(r => {
    const { AuthHash } = r.body[0]
    dispatch({ type: constants.BEGIN_IMPERSONATION, impersonatedUser: { ...impersonatedUser, AuthHash } })
    if (History.location.pathname !== '/') History.push('/')
  })
}

export const endImpersonation = (st) => dispatch => {
  dispatch({ type: constants.END_IMPERSONATION })
}

export const setOverrideUrl = (bool) => dispatch => {
  dispatch({ type: constants.SET_OVERRIDE_URL, overrideUrl: bool })
}